module.exports = __webpack_public_path__ + "static/index/img/baikal-601.194b72ac.jpg";